module.exports = __webpack_public_path__ + "static/media/flipTheCards_1.bae39cdb.mp3";